"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseSummaryTpl = exports.getQuestionSummary = exports.getModel = exports.getChoicesSummaryValue = void 0;
var _constants = require("../../../utils/constants");
var _services = require("../../../services");
const getChoicesSummaryValue = function (selections) {
  var _summaryDelimiter$;
  let summaryDelimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (selections.length === 1) {
    return selections[0];
  }
  const firstSelections = selections.slice(0, -1);
  const lastSelection = selections.slice(-1);
  const firstDelimiter = summaryDelimiter[0];
  const lastDelimiter = (_summaryDelimiter$ = summaryDelimiter[1]) !== null && _summaryDelimiter$ !== void 0 ? _summaryDelimiter$ : summaryDelimiter[0];
  return [firstSelections.join(firstDelimiter), lastSelection].join(lastDelimiter);
};
exports.getChoicesSummaryValue = getChoicesSummaryValue;
const getModel = value => {
  switch (true) {
    case value >= 0 && value <= 0.3:
      return _services.Services.locale.localeString('Summary.basic');
    case value >= 0.4 && value <= 0.7:
      return _services.Services.locale.localeString('Summary.medium');
    case value >= 0.8 && value <= 1:
      return _services.Services.locale.localeString('Summary.latest');
    default:
      return [];
  }
};
exports.getModel = getModel;
const parseSummaryTpl = (tpl, value) => {
  var _tpl$replace;
  let jsonName, jsonStreetNumber;
  try {
    jsonName = JSON.parse(value).name;
    jsonStreetNumber = JSON.parse(value).selectedStreetNr;
  } catch {
    jsonName = '';
    jsonStreetNumber = '';
  }
  return tpl === null || tpl === void 0 ? void 0 : (_tpl$replace = tpl.replace('{{value}}', `<value>${value}</value>`)) === null || _tpl$replace === void 0 ? void 0 : _tpl$replace.replace('{{currencyValue}}', `<value>${_services.Services.locale.formatPrice(value, {
    fraction: false
  })}</value>`).replace('{{addressValue}}', `<value>${jsonName}, ${jsonStreetNumber}</value>`).replace('{{modelValue}}', `<value>${getModel(value)}</value>`);
};
exports.parseSummaryTpl = parseSummaryTpl;
const getQuestionSummary = (question, selections) => {
  let summaryTpl = question.summary;
  if (typeof question.summary === 'object') {
    summaryTpl = selections.length > 1 ? question.summary.multi : question.summary.single;
  }
  switch (question.type) {
    case _constants.QUESTION_TYPE.CHOICES:
      {
        if (question.summaryMaxSelections && selections.length > question.summaryMaxSelections) {
          return;
        }
        if (selections.length === 1) {
          const choice = question.choices.find(c => selections.includes(c.text));
          if (choice.summary) {
            summaryTpl = choice.summary;
          }
        }
        if (!summaryTpl || summaryTpl === '-') {
          return;
        }
        selections = question.choices.filter(c => selections.includes(c.text)).map(c => c.summaryText || c.text).map(selection => `<value>${selection}</value>`);
        const summaryValue = getChoicesSummaryValue(selections, question.summaryDelimiter);
        return summaryTpl.replace(/{{value}}/g, summaryValue);
      }
    case _constants.QUESTION_TYPE.MULTI:
      {
        if (!summaryTpl) {
          return;
        }
        selections.forEach(selection => {
          summaryTpl = parseSummaryTpl(summaryTpl, selection);
        });
        return summaryTpl;
      }
    case _constants.QUESTION_TYPE.RANGE:
      {
        if (typeof question.summary === 'object' && selections.length) {
          summaryTpl = selections[0] == 1 ? question.summary.single : question.summary.multi;
        }
        return parseSummaryTpl(summaryTpl, selections[0]);
      }
    default:
      {
        if (!summaryTpl) {
          return;
        }
        const summaryValue = selections[0];
        return parseSummaryTpl(summaryTpl, summaryValue);
      }
  }
};
exports.getQuestionSummary = getQuestionSummary;